module.exports = __webpack_public_path__ + "static/vision-7ebae907cd93ed2747928db7f5580cf6.jpg";